import { render, staticRenderFns } from "./VerPdfGerente.vue?vue&type=template&id=18f96b79&scoped=true"
import script from "./VerPdfGerente.vue?vue&type=script&lang=js"
export * from "./VerPdfGerente.vue?vue&type=script&lang=js"
import style0 from "./VerPdfGerente.vue?vue&type=style&index=0&id=18f96b79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f96b79",
  null
  
)

export default component.exports